import { Dispatch, SetStateAction } from 'react';
import { NContact } from '../../../Contact/validation';

export interface IDocsMenuProps {
  allowDroppedDocGenAndDocuSign?: boolean;
  handleMenuItemClick: (item: IDocsMenu) => void;
}

export interface IDocumentGenerate {
  dealId: string;
  documentGenerationType: number;
  ignoreProducts: boolean;
  isEmailCustomerTitleDocGen: boolean;
  isScanStipTitleDocGen: boolean;
  filterDocumentTypeIds: string[];
}

export interface IDocsMenu {
  docTypeId: number;
  id: number;
  name: string;
  isCustom?: boolean;
  divider?: boolean;
  docuSign?: boolean;
  title?: boolean;
}

export interface ICustomDocsModalProps {
  customDocModalPosition: number;
  dealId: string;
  docMenuItem: IDocsMenu;
  handleDoc: (docsData: IDocumentGenerate, docMenuItem: IDocsMenu, docModalSubmitted: boolean) => void;
  onClose: () => void;
}

export interface ICustomDocs {
  setOpenAlert: Dispatch<SetStateAction<boolean>>;
  setOpenModal: Dispatch<SetStateAction<number>>;
  openAlert: boolean;
  customDocModalPosition: number;
  docMenuItem: IDocsMenu;
  assetId?: string;
  contact?: NContact.Entity;
  handleDoc: (docsData: IDocumentGenerate, docMenuItem: IDocsMenu, docModalSubmitted: boolean) => void;
  onClose: () => void;
}

export interface ICustomDocsProps {
  customDocsList: ICustomDocsList[];
  values: IDocumentGenerate;
}

export interface ICustomDocsList {
  id: string;
  name: string;
}

export interface IDocuSign {
  dealId: string;
  isCustomDocuSign: boolean;
  documentGenerationType: number;
  shouldSendToCoBorrowerForCustomDocuSign: boolean;
  requiresDroppedDocuSign: boolean;
}

export interface IDocuSignAlertProps {
  openDocuSignAlert: boolean;
  setOpenDocuSignAlert: Dispatch<SetStateAction<boolean>>;
  dealId: string;
  documentGeneratedType: number;
  customDocuSign: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setLoaderText: (value: React.SetStateAction<string | undefined>) => void;
}

export interface ITitleAlertProps {
  openTitleAlert: boolean;
  setOpenTitleAlert: Dispatch<SetStateAction<boolean>>;
  docMenuItem: IDocsMenu;
  onDocGenerate: (docsData: IDocumentGenerate, docMenuItem: IDocsMenu) => Promise<void>;
  assetId?: string;
  contact?: NContact.Entity;
  filterDocumentTypeIds: string[]
}

interface IDocsItem {
  [key: string]: number;
}

export const DOC_TYPES = {
  LENDER: 1,
  TITLE_APP: 2,
  TITLE_DOCS: 3,
  TITLE_AUDIT: 4,
  DROPPED_DOC: 5,
  RECONCILATION_SHEET: 6
};

export const DOC_GEN_TITLE_MENU: IDocsMenu[] = [
  {
    docTypeId: DOC_TYPES.TITLE_DOCS,
    id: 7,
    name: 'Title Doc Gen',
    title: true,
  },
  {
    docTypeId: DOC_TYPES.TITLE_DOCS,
    id: 8,
    name: 'Title Doc Gen-Email Customer',
    title: true,
  },
  {
    docTypeId: DOC_TYPES.TITLE_DOCS,
    id: 9,
    name: 'Title Doc Gen - STIPS Scan',
    title: true,
  },
  {
    docTypeId: DOC_TYPES.TITLE_DOCS,
    id: 10,
    name: 'Custom-Title Doc Gen',
    isCustom: true,
    title: true,
  },
  {
    docTypeId: DOC_TYPES.TITLE_DOCS,
    id: 11,
    name: 'Custom-Title Doc Gen - Email Customer',
    isCustom: true,
    title: true,
  },
  {
    docTypeId: DOC_TYPES.TITLE_DOCS,
    id: 12,
    name: 'Custom-Title Doc Gen - STIPS Scan',
    isCustom: true,
    title: true,
    divider: true,
  },
  {
    docTypeId: DOC_TYPES.TITLE_AUDIT,
    id: 13,
    name: 'Title Audit',
    divider: true,
  },
  {
    docTypeId: DOC_TYPES.TITLE_APP,
    id: 14,
    name: 'Title App',
    divider: true,
  },
  {
    docTypeId: DOC_TYPES.RECONCILATION_SHEET,
    id: 15,
    name: 'Reconcilation Sheet',
  },
];

export const DOC_GEN_LENDER_MENU: IDocsMenu[] = [
  {
    docTypeId: DOC_TYPES.LENDER,
    id: 1,
    name: 'Doc Gen',
  },
  {
    docTypeId: DOC_TYPES.LENDER,
    id: 2,
    name: 'Doc Gen & Docu Sign',
    docuSign: true,
  },
  {
    docTypeId: DOC_TYPES.LENDER,
    id: 3,
    name: 'Custom Doc Gen',
    isCustom: true,
  },
  {
    docTypeId: DOC_TYPES.LENDER,
    id: 4,
    name: 'Custom-Doc Gen & Docu Sign',
    isCustom: true,
    docuSign: true,
    divider: true,
  }
];

export const DOC_GEN_LENDER_DROPPED_MENU = [
  {
    docTypeId: DOC_TYPES.DROPPED_DOC,
    id: 5,
    name: 'Dropped Doc Gen',
  },
  {
    docTypeId: DOC_TYPES.DROPPED_DOC,
    id: 6,
    name: 'Dropped Doc Gen & Docu Sign',
    docuSign: true,
    divider: true,
  }
];

export const MENU_ITEMS = DOC_GEN_LENDER_MENU.concat(DOC_GEN_LENDER_DROPPED_MENU, DOC_GEN_TITLE_MENU);

export const DOCS_MENU: IDocsItem = MENU_ITEMS.reduce((item, value) => {
  return { ...item, [value.name]: value.id };
}, {});
